import Button from "./button";
const FitButton = ({ children, handleClick, ...props }) => {
  return (
    <Button handleClick={handleClick} {...props} additionalclasses={`!w-fit !py-[7.73px] !px-[15.45px] !rounded-[6.182px] custom-text-grey-50 !text-[12px] poppins-regular !mt-0 ${props.additionalclasses || ''}`}>
      {children}
    </Button>
  );
};

// FitButton.defaultProps = {
//   additionalclasses: "!w-fit !py-[7.73px] !px-[15.45px] !rounded-[6.182px] custom-text-grey-50 !text-[12px] poppins-regular !mt-0 ",
// };
export default FitButton;
